import { all, call, put, takeEvery } from 'redux-saga/effects'

import { changeModal } from 'services/actions'
import mixpanel, { EVENTS } from 'lib/mixpanel'

import { loadShowcasesSaga } from './filter/saga'
import { LIKE_SHOWCASE, TOGGLE_SHOWCASE_STATUS } from './actions'

import { likeShowcaseService, postShowcaseService } from './index'

export function* likeShowcaseSaga({
  payload: { showcaseId, showcaseSlug },
}: {
  payload: { showcaseId: string; showcaseSlug: string; isStatic?: boolean }
}): Generator<unknown, void, unknown> {
  yield call(likeShowcaseService.requestSaga as (opts: unknown) => Generator, {
    payload: {
      data: { showcase_id: showcaseId },
    },
  })
  mixpanel.track(EVENTS.LIKE_SHOWCASE_POST, {
    showcase_slug: showcaseSlug,
  })
  yield* loadShowcasesSaga()
}

export function* toggleShowcaseSaga({
  payload: { showcaseId, schoolId = null, status },
}: {
  payload: { showcaseId: string; schoolId: string | null; status: string }
}): Generator<unknown, void, unknown> {
  yield call(postShowcaseService.requestSaga as (opts: unknown) => Generator, {
    payload: {
      data: {
        id: showcaseId,
        school_id: schoolId,
        status,
      },
    },
  })
  yield* loadShowcasesSaga()
  yield put(changeModal({ isOpen: false }))
}

type LikeShowcaseAction = {
  type: typeof LIKE_SHOWCASE
  payload: { showcaseId: string; showcaseSlug: string; isStatic?: boolean }
}
type ToggleShowcaseStatusAction = {
  type: typeof TOGGLE_SHOWCASE_STATUS
  payload: { showcaseId: string; schoolId: string | null; status: string }
}

export default function* saga(): Generator<unknown, void, unknown> {
  yield all([
    takeEvery<LikeShowcaseAction>(LIKE_SHOWCASE, likeShowcaseSaga),
    takeEvery<ToggleShowcaseStatusAction>(TOGGLE_SHOWCASE_STATUS, toggleShowcaseSaga),
  ])
}
